// ES6 Map/Set Polyfills
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/array/includes';
import 'core-js/fn/string/includes';
// import 'raf/polyfill';

// HTMLCollection & NodeList remove() function
// https://stackoverflow.com/questions/3387427/remove-element-by-id/18120786#18120786
Element.prototype.remove = function() {
  this.parentElement.removeChild(this);
};
NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
  for (var i = this.length - 1; i >= 0; i--) {
    if (this[i] && this[i].parentElement) {
      this[i].parentElement.removeChild(this[i]);
    }
  }
};

// event.target.closest polyfill
if (!Element.prototype.matches)
  Element.prototype.matches =
    Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest)
  Element.prototype.closest = function(s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };



// WEBPACK FOOTER //
// ./src/polyfills.js